import { parseSimpleDate } from '@legalosApi/helpers/parseSimpleDate';
import ISimpleDateObject from '@legalosApi/types/ISimpleDateObject';
import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { Props } from './QuestionInput';
import './quest-input-date.scss';

export function DateInput(props: Props<ISimpleDateObject>) {
  const ref = React.createRef<HTMLInputElement>();
  React.useEffect(() => {
    const { current } = ref;
    if (current) current.focus();
  });

  const handleChange = (value: Date | null) => {
    if (value && value instanceof Date) {
      props.onChange({
        day: value.getDate(),
        month: value.getMonth(),
        year: value.getFullYear(),
      });
    }
  };

  useEffect(() => {
    if (!props.value) {
      handleChange(new Date());
    }
  }, []);

  const selected = new Date();

  // The value may still arrive as the JSON string an AUTO question once stored;
  // an unparsable value falls back to today instead of an Invalid Date.
  const current = parseSimpleDate(props.value);
  if (current) {
    selected.setUTCFullYear(current.year, current.month, current.day);
  }

  return <DatePicker className="dtUiInput" dateFormat="dd.MM.yyyy" selected={selected} onChange={handleChange} />;
}
